'use client';

import { useEffect } from 'react';
import { isCart, isCheckout } from '@next-app/utils/common-utils';
import constants from '../constants/constants';

const MultipleTabManagement = () => {
  const storageKeys = constants.browserStorageKeys;

  const getTimestamp = () => {
    return new Date().getTime().toString();
  };

  const setTimestamps = () => {
    const currentTime = getTimestamp();
    sessionStorage.setItem(storageKeys.sessionStorageTimestamp, currentTime);
    localStorage.setItem(storageKeys.localStorageTimestamp, currentTime);
  };

  const compareTimestamps = () => {
    const checkForReload = isCart() || isCheckout();
    const sessionTimestamp = sessionStorage.getItem(
      storageKeys.sessionStorageTimestamp,
    );
    const localTimestamp = localStorage.getItem(
      storageKeys.localStorageTimestamp,
    );
    if (checkForReload && sessionTimestamp !== localTimestamp) {
      console.log('Reloading while comparing session timestamp!');
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    } else {
      setTimestamps();
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        compareTimestamps();
      }
    };
    window.addEventListener('visibilitychange', handleVisibilityChange);
    setTimestamps();
    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
};

export default MultipleTabManagement;
